import React from 'react';
import {Button} from '@insticator/insticator-ui'; // iui-material

const ActionButtons = (props) => {
  const {
    handlePreview,
    handleCancel,
    handleSave,
    handleDownload,
    isChanged,
    previewTitle,
    cancelTitle,
    saveTitle,
    downloadTitle,
    isDownloading,
    // isLoading,
    isProcessing,
    processingTitle,
    disableSave,
    disableCancel
  } = props;
  return (
    <>
      <div>
        {handlePreview && <Button
          variant={'normal'}
          text={previewTitle || 'Preview'}
          type={'action'}
          handleClick={handlePreview}
          />}
      </div>
      <div>
      {handleDownload && <Button
          variant={'primary'}
          text={downloadTitle || 'Download'}
          type={'action'}
          handleClick={handleDownload}
          disabled={isDownloading}
      />}
      {handleCancel && <Button
        variant={'system'}
        text={cancelTitle || 'Cancel'}
        type={'action'}
        handleClick={handleCancel}
        disabled={disableCancel}
        // disabled={isLoading}
      />}
      {handleSave && <Button
        variant={'primary'}
        text={saveTitle || 'Save & Close'}
        type={'action'}
        handleClick={handleSave}
        disabled={isProcessing || isChanged === false || disableSave}
        operation={'save'}
        processing={isProcessing}
        processingText={processingTitle}
      />}
      </div>
    </>
  )
};

export default ActionButtons
